import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { Banner } from "@similarweb/ui-components";

export const StyledBanner = styled(Banner)`
    padding: 16px 24px;
    border-radius: 6px;
    background-color: rgb(236, 241, 255);
    margin-bottom: 62px;
    margin-top: -30px;
    @media (max-width: 1600px) {
        margin-bottom: 54px;
        margin-top: -22px;
    }
    @media (max-width: 1400px) {
        margin-bottom: 36px;
        margin-top: -4px;
    }
`;

export const StyledProminentBanner = styled(Banner)`
    padding: 16px 24px;
    border-radius: 6px;
    margin-bottom: 62px;
    margin-top: -30px;
    background: radial-gradient(
        186.15% 140.12% at 100% 0%,
        #78bfff 0.05%,
        #8fc4ff 6.02%,
        #609dff 26.04%,
        #4683ff 41.67%,
        #5887ff 100%
    );

    @media (max-width: 1600px) {
        margin-bottom: 54px;
        margin-top: -22px;
    }
    @media (max-width: 1400px) {
        margin-bottom: 36px;
        margin-top: -4px;
    }

    & p {
        color: ${colorsPalettes.carbon[0]};
    }

    & button ~ div {
        .SWReactIcons svg {
            path {
                fill: ${colorsPalettes.carbon[0]};
            }
        }
        &:hover {
            .SWReactIcons svg {
                path {
                    fill: ${colorsPalettes.carbon[200]};
                }
            }
        }
    }
`;
